module.exports = __webpack_public_path__ + "static/assets/fb4bf7e78883c67f5ab1a88278b53ebc.png";